import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <div className="footer-logo">half<span>price</span>.ca</div>
          <p>Winnipeg's local restaurant deals platform.<br />Powered by Izenious Tech Solutions.</p>
          <p className="footer-address">Winnipeg, Manitoba, Canada</p>
        </div>
        <div className="footer-col">
          <h4>For Diners</h4>
          <Link to="/deals">Browse deals</Link>
          <Link to="/how-it-works">How it works</Link>
        </div>
        <div className="footer-col">
          <h4>For Restaurants</h4>
          <Link to="/business/register">List your restaurant</Link>
          <Link to="/pricing">Pricing plans</Link>
          <Link to="/business/login">Restaurant login</Link>
        </div>
        <div className="footer-col">
          <h4>Company</h4>
          <a href="mailto:hello@halfprice.ca">hello@halfprice.ca</a>
          <Link to="/careers">Careers</Link>
          <Link to="/sitemap">Site map</Link>
        </div>
        <div className="footer-col">
          <h4>Legal</h4>
          <Link to="/terms">Terms of Use</Link>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/accessibility">Accessibility</Link>
        </div>
      </div>
      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} halfprice.ca · Izenious Tech Solutions</span>
        <Link to="/admin/login" className="footer-admin-link">Admin sign in</Link>
      </div>
    </footer>
  );
}
